<template>
  <div class="container">
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 class>Novo Beneficio</h3>
            </div>
            <div class="col-auto">
              <b-button @click="voltar">Voltar</b-button>
            </div>
          </div>
        </div>
        <div class="element-box">
          <form @submit.prevent="salvar()">
            <div class="row">
              <div class="col-md-4 form-group">
                <label>Permite acima de 70 anos?</label>
                <input type="checkbox" v-model="beneficio.permiteAcimaDe70Anos"
                       class="form-control">
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group">
                <label>Nome</label>
                <input type="text" v-model="beneficio.nome" class="form-control"
                  :disabled="isEdit">
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-group">
                <label>Título</label>
                <input type="text" v-model="beneficio.titulo" class="form-control">
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-group">
                <label>Descrição</label>
                <textarea cols="30" rows="8" v-model="beneficio.descricao" class="form-control">
                </textarea>
              </div>
            </div>
            <hr>
            <div class="row ">
              <div class="col-md-6 mr-auto form-group">
                <label>Passo a Passo dos benefícios <small>(texto usado no email)</small></label>
              </div>
              <div class="col-auto">
                <b-button v-b-modal.modal-textoBeneficio>Novo</b-button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Ordem</th>
                      <th>Texto</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(t, i) in beneficio.textoBeneficios" :key="i">
                      <td>{{i+1}}</td>
                      <td>{{t}}</td>
                      <td>
                        <b-button title="Excluir" variant="light" @click.stop="excluir(i)">
                          <i class="fas fa-trash"></i>
                        </b-button>
                        <b-button v-if="i > 0" variant="light" @click.stop="alterarPosicao('up', i)">
                          <i class="fas fa-arrow-up"></i>
                        </b-button>
                        <b-button v-if="i >= 0 && (i+1) !== beneficio.textoBeneficios.length" variant="light"
                                  @click.stop="alterarPosicao('down', i)">
                          <i class="fas fa-arrow-down"></i>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col center-block">
                <button class="btn btn-primary" type="submit">Salvar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <b-modal id="modal-textoBeneficio" title="Adicionar novo texto de passo a passo"
    @ok="add">
        <div class="container">
          <div class="row">
            <div class="col form-group">
              <label>Texto</label>
              <textarea cols="30" rows="8" v-model="texto" class="form-control">
                </textarea>
            </div>
          </div>
        </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "BeneficioForm",
  async created() {
    const {id} = this.$route.query;
    this.id = id;
    if (this.id) {
      this.beneficio = await axios.get(`/api/beneficio/${this.id}`)
          .then(response => response.data);
    }
  },
  data: () => ({
    id: null,
    beneficio: {
      textoBeneficios: []
    },
    texto: null
  }),
  computed: {
    isEdit() {
      return this.id !== undefined;
    }
  },
  methods: {
    voltar() {
      window.history.back();
    },
    add() {
      this.beneficio.textoBeneficios.push(this.texto);
      this.texto = null;
    },
    alterarPosicao(tipo, index) {
      const elm = this.beneficio.textoBeneficios.splice(index, 1)[0];

      const to = tipo === 'up' ? --index : ++index;

      this.beneficio.textoBeneficios.splice(to, 0, elm);
    },
    excluir(index) {
      this.beneficio.textoBeneficios.splice(index, 1);
    },
    async salvar() {
      if (this.beneficio._id) {
        await axios.put(`/api/beneficio/${this.beneficio._id}`, this.beneficio);
      } else {
        await axios.post('/api/beneficio', this.beneficio);
      }

      this.$router.push({name: 'BeneficioList'});
    }
  }
}
</script>

<style scoped>

</style>
